import { render, staticRenderFns } from "./ReportsId.vue?vue&type=template&id=6e1b8c1b&scoped=true"
import script from "./ReportsId.vue?vue&type=script&lang=js"
export * from "./ReportsId.vue?vue&type=script&lang=js"
import style0 from "./ReportsId.vue?vue&type=style&index=0&id=6e1b8c1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b8c1b",
  null
  
)

export default component.exports